/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type SitesListSiteTypesItem = (typeof SitesListSiteTypesItem)[keyof typeof SitesListSiteTypesItem]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SitesListSiteTypesItem = {
  BASIC: 'BASIC',
  MANUAL: 'MANUAL'
} as const
